export const ROLES = ['No Role', null, 'Affiliate', 'ES', 'Admin']

export const ROLES_DESCRIPTION = ['No Role', '', 'Affiliate', 'ES', 'Administrator']

export enum UserRole {
  NO_ROLE = 0,
  CS = 1,
  AFFILIATE = 2,
  ES = 3,
  ADMIN = 4
}

export enum Permission {
  EAI_LICENSES = 'EAI_LICENSES_PERMISSION',
  PRODUCT_PERMISSION = 'PRODUCT_PERMISSION'
}

export enum EAI_LICENSES_PERMISSION {
  ALLOW = 1,
  NOT_ALLOW = 0
}

export enum PRODUCT_PERMISSION {
  ALLOW = 1,
  NOT_ALLOW = 0
}
